import { Component, OnInit } from '@angular/core';
import { selectSaHeaderTaxRates, selectStandingAuthPendForRelease, selectTransactionType, selectTwePopupIndicator } from '../../reducers';
import { Store } from '@ngrx/store';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { selectHasAccessInitiateMoneyMovement } from '../../../authorize/reducers';
import { selectInitReleaseTransactionInContext } from '../../../initiate-and-release/reducers';
import { DraftListTableColumn } from '../../../initiate-and-release/Models/Drafts/DraftResponse';
import { mapInitiatedDraftsToTableColumn } from '../../../create-request/components/transactions-table/table-helpers';
import { selectViewInContext } from '../../../shared/reducers';
import { pageInContext } from '../../../shared/utilities/Constants';
import { AccountInfoActions } from '../../../account-info-header/actions';

@Component({
  standalone: false,
  selector: 'mm-sa-transaction-review',
  templateUrl: './sa-transaction-review.component.html',
  styleUrls: ['./sa-transaction-review.component.scss']
})
export class SaTransactionReviewComponent implements OnInit {
  subscriptionNotifier: Subject<boolean> = new Subject()
  transactionType: string | undefined;
  destroy$: Subject<boolean> = new Subject()
  hasMmInitiateAccess: boolean = false;
  isPendForRelease: boolean = false;
  draftInContext: DraftListTableColumn;

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.store.select(selectTransactionType).pipe(takeUntil(this.subscriptionNotifier)).subscribe((val) => {
      this.transactionType = val;
    });

    this.store.select(selectHasAccessInitiateMoneyMovement)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        this.hasMmInitiateAccess = response;
      });

    this.store.select(selectStandingAuthPendForRelease).pipe(takeUntil(this.destroy$)).subscribe(shouldPendForRelease => {
        this.isPendForRelease = shouldPendForRelease;
      });

    this.store.select(selectInitReleaseTransactionInContext).subscribe(value => {
      this.draftInContext = mapInitiatedDraftsToTableColumn(value);
    });

    combineLatest([
      this.store.select(selectViewInContext),
      this.store.select(selectTwePopupIndicator),
      this.store.select(selectSaHeaderTaxRates)
    ]).pipe(
      filter(([step, openTwePopup]) => step === pageInContext.confirmation && openTwePopup),
      take(1),
      takeUntil(this.destroy$)
    ).subscribe(([, , taxes]) => {
      this.store.dispatch(AccountInfoActions.updateHeaderTaxRates({
        federalTaxRate: taxes.fedTaxPercent,
        stateTaxRate: taxes.stateTaxPercent
      }));
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.subscriptionNotifier.next(true)
    this.subscriptionNotifier.unsubscribe()
  }

  loadTransactionDetailsWireIsoComponent(): boolean {
    return this.transactionType === 'wire';
  }

  get isInitiateAndReleaseFlowFromTable(): boolean {
    return this.hasMmInitiateAccess && !!this.draftInContext?.DraftId;
  }

}
